import React from "react";
import { ThinTextField } from "../../common/GeneralComponent";

const GeneralInformation = ({ data }) => {
  if (!data) {
    return (
      <div className="text-center py-8 text-gray-500">
        No data available
      </div>
    );
  }

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  const dateOfVisit = formatDateTime(data.date_of_visit);
  const visitorName = data.created_by?.name || "N/A";
  const designation = data.created_by?.designation || "N/A";
  const organization = data.created_by?.organization || data.created_by?.partner_organization_name || "N/A";
  const partnerName = data.created_by?.partner_organization_name || "N/A";
  const districtName = data.district_name || "N/A";
  const tehsilName = data.tehsil_name || "N/A";
  const ucName = data.uc_name || "N/A";
  const dehName = data.deh_name || "N/A";
  const villageName = data.village_name || "N/A";
  const latitude = data.latitude || "N/A";
  const longitude = data.longitude || "N/A";

  return (
    <div className="bg-white rounded p-4">
      <form className="w-full">
        {/* First Row - Date, Visitor, Designation */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Date of Visit"
            value={dateOfVisit}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Name of Visitor"
            value={visitorName}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Designation"
            value={designation}
            disabled
          />
        </div>

        {/* Second Row - Organization, Partner, District */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Organization"
            value={organization}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Partner Organization"
            value={partnerName}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="District"
            value={districtName}
            disabled
          />
        </div>

        {/* Third Row - Tehsil, UC, Deh */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Tehsil / Taluka"
            value={tehsilName}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="UC"
            value={ucName}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Deh"
            value={dehName}
            disabled
          />
        </div>

        {/* Fourth Row - Village, Latitude, Longitude */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <ThinTextField
            isRequired={false}
            label="Village"
            value={villageName}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Latitude"
            value={latitude}
            disabled
          />
          <ThinTextField
            isRequired={false}
            label="Longitude"
            value={longitude}
            disabled
          />
        </div>
      </form>
    </div>
  );
};

export default GeneralInformation;